export default __webpack_public_path__ + "static/media/spinner-white.ebc498aa.svg";